import { useContext } from 'react';

import { WorkspaceContext } from './workspace-context';

// ----------------------------------------------------------------------

export function useWorkspaceContext() {
  const context = useContext(WorkspaceContext);

  if (!context) {
    throw new Error('useWorkspaceContext: Context must be used inside WorkspaceProvider');
  }

  return context;
}
